import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'
import { colorBrandPrimary } from '../../../../global.style'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${colorBrandPrimary.turquoise};

  ${media.desktop`
    height: fit-content;
  `}
  height: 250px;
  
`

export const Container = styled.div`
  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
  display: flex;
  width: 80%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  `

export const TextWrap = styled.div`
  padding: 20px;
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
    max-width: 100%;
    line-height: 28px;
  `}
  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 300px;
  margin-bottom: 10px;
  line-height: 45px;
`

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 400px;
`

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 90%;
    height: 100%;
    margin-top: 15px;
  `}
  height: 200px;
`